import {
  Apple,
  ArrowRight,
  Cloud,
  Crown,
  Gamepad2,
  ShieldCheck,
  Sparkles,
  Trophy,
  UserRound,
  UsersRound,
} from "lucide-react";
import styles from "./FriendsView.module.css";

export type LoginProvider = "Google" | "Microsoft" | "Apple";

interface FriendsViewProps {
  onLogin: (provider: LoginProvider) => void;
}

const benefits = [
  { icon: Cloud, label: "Spara XP" },
  { icon: UsersRound, label: "Hitta vänner" },
  { icon: Trophy, label: "Behåll badges" },
] as const;

export function FriendsView({ onLogin }: FriendsViewProps) {
  return (
    <main className={styles.view}>
      <header className={styles.header}>
        <div>
          <span className={styles.eyebrow}>Ditt party crew</span>
          <h1>Vänner</h1>
        </div>
        <div className={styles.signedOutBadge}>
          <span aria-hidden="true" />
          Utloggad
        </div>
      </header>

      <section className={styles.hero} aria-labelledby="guest-heading">
        <div className={styles.confetti} aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
          <i />
        </div>

        <div className={styles.partyOrbit} aria-hidden="true">
          <span className={styles.orbitLine} />
          <span className={styles.friendAvatar} data-position="left">
            <Sparkles />
          </span>
          <span className={styles.friendAvatar} data-position="right">
            <Crown />
          </span>
          <span className={styles.friendAvatar} data-position="top">
            <Gamepad2 />
          </span>
          <span className={styles.guestAvatar}>
            <UserRound />
            <small>Gäst</small>
          </span>
        </div>

        <span className={styles.guestLabel}>Gästläge är aktivt</span>
        <h2 id="guest-heading">
          Ta med ditt crew
          <br />
          till nästa nivå
        </h2>
        <p>
          Du kan spela direkt som gäst. Logga in för att lägga till vänner och
          låta progress, XP och badges följa med mellan enheter.
        </p>
      </section>

      <section className={styles.loginCard} aria-labelledby="login-heading">
        <div className={styles.loginHeading}>
          <span className={styles.cloudIcon}>
            <Cloud aria-hidden="true" />
          </span>
          <div>
            <span className={styles.eyebrow}>Säkra din progress</span>
            <h2 id="login-heading">Fortsätt med</h2>
          </div>
        </div>

        <div className={styles.providers}>
          <button type="button" onClick={() => onLogin("Google")}>
            <span className={styles.googleMark} aria-hidden="true">
              G
            </span>
            Google
            <ArrowRight aria-hidden="true" />
          </button>
          <button type="button" onClick={() => onLogin("Microsoft")}>
            <span className={styles.microsoftMark} aria-hidden="true">
              <i />
              <i />
              <i />
              <i />
            </span>
            Microsoft
            <ArrowRight aria-hidden="true" />
          </button>
          <button type="button" onClick={() => onLogin("Apple")}>
            <Apple aria-hidden="true" />
            Apple
            <ArrowRight aria-hidden="true" />
          </button>
        </div>

        <p className={styles.privacyNote}>
          <ShieldCheck aria-hidden="true" />
          Vi delar aldrig dina spelresultat utan ditt godkännande.
        </p>
      </section>

      <ul className={styles.benefits} aria-label="Fördelar med ett konto">
        {benefits.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </main>
  );
}
